import React from 'react';
import { Button } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useMsal, useAccount } from '@azure/msal-react';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateWriteoffMutation } from '../../../../services/WriteoffService';
import { clearBackupAction as clearBackup, markAsSavedAction as markAsSaved } from '../../../../services/WriteoffService/slice';

interface SaveChangesButtonProps {
  onError?: (message: string) => void;
  onSuccess?: () => void;
}

export const SaveChangesButton: React.FC<SaveChangesButtonProps> = ({ onError, onSuccess }) => {
  const dispatch = useAppDispatch();
  const { currentWriteoff, isEdited } = useAppSelector(state => state.writeoff);
  const [updateWriteoffMutation, { isLoading }] = useUpdateWriteoffMutation();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const handleSubmit = async () => {
    if (!currentWriteoff) return;

    const modifiedBy = account?.name || account?.username || 'System';
    const updatedWriteoff = {
      ...currentWriteoff,
      modifiedBy,
    };

    try {
      await updateWriteoffMutation({
        writeoffView: updatedWriteoff,
      }).unwrap();
      dispatch(markAsSaved());
      dispatch(clearBackup());
      onSuccess?.();
    } catch (err) {
      onError?.('Failed to save changes. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<SaveIcon />}
      onClick={handleSubmit}
      disabled={isLoading || !isEdited}
      sx={{
        backgroundColor: '#162346',
        '&:hover': {
          backgroundColor: '#1a2a52',
        },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Saving...' : 'Save Changes'}
    </Button>
  );
};

export default SaveChangesButton;
